import React from 'react';
import parseHTML from 'html-react-parser';
import Tip from '../../Tip/Tip';
import OfferDetailsBadge from './OfferDetailsBadge';

export function LeaseHeader() {
  return (
    <>
      <h2 className='ppq--web--offer-card--body--offer--label'>Lease</h2>
      <Tip
        content='[7] Special Lease offers applied to Estimated Capitalized Cost. Special Lease offers require Ford Credit Financing. Not all buyers will qualify. See dealer for qualifications and complete details.'
        header='Disclosure'
      >
        <span className='ppq--web--offer-card--body--offer--hint'>7</span>
      </Tip>
    </>
  );
}

export function LeaseContent({specialLease, appConfig}) {
  const expirationDateRaw = new Date(specialLease?.endDate);
  const expirationDate = `${expirationDateRaw.getUTCMonth() + 1}/${expirationDateRaw.getUTCDate()}/${expirationDateRaw.getUTCFullYear()}`;
  let content = (
    <span className='ppq--web--offer-card--body--offer--default'>
      Please contact your local dealer for the latest information on our current lease offers.
    </span>
  );
  if (specialLease?.detail) {
    content = parseHTML(specialLease.detail);
  }

  return (
    <div className='ppq--web--offer-card--body--offer--container'>
      {specialLease ? (
        <div className='ppq--web--offer-card--body--offer--special'>
          <div className='ppq--web--offer-card--body--offer--special--group'>
            <h2 className='ppq--web--offer-card--body--offer--special--label'>{specialLease ? 'Special Offer' : 'Current Offer'}</h2>
            {specialLease?.endDate ? (
              <span className='ppq--web--offer-card--body--offer--special--meta'>
                Expires: <span className='ppq--web--offer-card--body--offer--special--highlight'>{expirationDate}</span>
              </span>
            ) : null}
          </div>
          <Tip content={specialLease?.disclaimer} header='Offer Details'>
            <OfferDetailsBadge />
          </Tip>
        </div>
      ) : null}
      {appConfig.removeVehicleTrimInfoFlag && specialLease?.name && <div className='campaign-name'>{parseHTML(specialLease?.name)}</div>}

      <div className='ppq--web--offer-card--body--offer--content ppq--web--offer-card--body--offer--content-lease'>{content}</div>
    </div>
  );
}

function getLeaseTab(specialLease, appConfig) {
  return {
    header: <LeaseHeader />,
    content: <LeaseContent specialLease={specialLease} appConfig={appConfig} />,
    id: 'lease'
  };
}

export default getLeaseTab;
